import { useCallback } from 'react'

import { usePathname, useRouter, useSearchParams } from 'next/navigation'

/**
 * WARNING: Works only for paths using the App Router.
 */
export const useTabsUrlParams = () => {
  const router = useRouter()
  const searchParams = useSearchParams()
  const pathname = usePathname()
  const updateTabUrlParam = useCallback(
    (newTab: string) => {
      const updatedQuery = new URLSearchParams(searchParams?.toString())
      updatedQuery.set('tab', newTab)
      router.push(`${pathname}?${updatedQuery.toString()}`, { scroll: false })
    },
    [router, pathname, searchParams]
  )

  const tab = searchParams?.get('tab') || undefined
  return {
    tab,
    updateTabUrlParam,
  }
}
